export const ColumnsRates = [
    {
        headerName: 'Nome',
        type: 'string',
        value: {
            first: {
                value: 'name'
            }
        }
    },
    {
        headerName: 'Taxa',
        type: 'percent',
        value: {
            first: {
                value: 'value_rate'
            }
        }
    },
    {
        headerName: 'Date Rate',
        type: 'date',
        value: {
            first: {
                value: 'date_rate'
            }
        }
    },
    {
        headerName: 'Fator',
        type: 'percent',
        value: {
            first: {
                value: 'factor'
            }
        }
    },
    {
        headerName: 'Usuário',
        type: 'string',
        value: {
            first: {
                value: 'username'
            }
        }
    },
    {
        headerName: 'Criado',
        type: 'date',
        value: {
            first: {
                value: 'created_at'
            }
        }
    },
    {
        headerName: 'Atualizado',
        type: 'date',
        value: {
            first: {
                value: 'updated_at'
            }
        }
    },
];

export const ColumnsFocusReport = [
    // {
    //     headerName: 'Ano',
    //     type: 'string',
    //     value: {
    //         first: {
    //             value: 'base_year'
    //         }
    //     }
    // },
    {
        headerName: 'Publicado',
        type: 'date',
        value: {
            first: {
                value: 'published_at'
            }
        }
    },
    {
        headerName: 'IPCA 4W',
        type: 'percent',
        value: {
            first: {
                value: 'ipca_four_weeks'
            }
        }
    },
    {
        headerName: 'IPCA 1W',
        type: 'percent',
        value: {
            first: {
                value: 'ipca_one_week'
            }
        }
    },
    {
        headerName: 'IPCA Hoje',
        type: 'percent',
        value: {
            first: {
                value: 'ipca_today'
            }
        }
    },
    {
        headerName: 'SELIC 4W',
        type: 'percent',
        value: {
            first: {
                value: 'selic_four_weeks'
            }
        }
    },
    {
        headerName: 'SELIC 1W',
        type: 'percent',
        value: {
            first: {
                value: 'selic_one_week'
            }
        }
    },
    {
        headerName: 'SELIC Hoje',
        type: 'percent',
        value: {
            first: {
                value: 'selic_today'
            }
        }
    },
    {
        headerName: 'Câmbio USD 4W',
        type: 'percent',
        value: {
            first: {
                value: 'exchange_rate_brlusd_four_weeks'
            }
        }
    },
    {
        headerName: 'Câmbio USD 1W',
        type: 'percent',
        value: {
            first: {
                value: 'exchange_rate_brlusd_one_week'
            }
        }
    },
    {
        headerName: 'Câmbio USD Hoje',
        type: 'percent',
        value: {
            first: {
                value: 'exchange_rate_brlusd_today'
            }
        }
    },
    {
        headerName: 'GDP 4W',
        type: 'percent',
        value: {
            first: {
                value: 'gdp_four_weeks'
            }
        }
    },
    {
        headerName: 'GDP 1W',
        type: 'percent',
        value: {
            first: {
                value: 'gdp_one_week'
            }
        }
    },
    {
        headerName: 'GDP Hoje',
        type: 'percent',
        value: {
            first: {
                value: 'gdp_today'
            }
        }
    },
    {
        headerName: 'Usuário',
        type: 'string',
        value: {
            first: {
                value: 'username'
            }
        }
    },
    {
        headerName: 'Criado',
        type: 'date',
        value: {
            first: {
                value: 'created_at'
            }
        }
    },
    {
        headerName: 'Atualizado',
        type: 'date',
        value: {
            first: {
                value: 'updated_at'
            }
        }
    },
]